import React from 'react';
import StockGlobalProductForm from 'forms/StockGlobalProductForm';

export default (): JSX.Element => <StockGlobalProductForm />;
